(ns frontend.view.modals.entity.attributes)

(defonce asset-attributes [:asset/name])
(defonce funding-round-attributes [:funding-round/value])
(defonce webentry-attributes [:webentry/display-name])
(defonce named-value-attributes [:named-value/value])
(defonce stage-attributes [:stage/name])
(defonce opportunity-stage-attributes [:opportunity-stage/name])
(defonce sales-opportunity-stage-attributes [:sales-opportunity-stage/name])
(defonce exit-opportunity-stage-attributes [:exit-opportunity-stage/name])
(defonce real-estate-create-attributes
  (concat asset-attributes
          [:real-estate/lettable-area :asset/street-address :asset/city :asset/country
           :real-estate/property-type]))

(defonce company-create-attributes
         (concat asset-attributes [] [:company/website :asset/description :company/sector]))
(defonce fof-asset-create-attributes
         (concat asset-attributes
                 []
                 [:fof-asset/gp :fof-asset/target-asset-class
                  :fof-asset/datetime-fundraising-until]))
(defonce
 person-create-attributes
 [:person/universal-email-address :person/first-name :person/last-name :person/universal-title
  :person/universal-phone-number
  :person/mobile-phone-number
  :person/work-phone-number
  :person/work-email-address
  :person/other-email-addresses
  :person/location-city
  :person/location-country
  :person/linkedin-url
  :person/notes
  :person/tag-tags])

(defonce holding-create-attributes
         [:holding/name
          :holding/owner
          :holding/target-asset
          :holding/exit-status
          :holding/cur-paid-in-capital
          :holding/cur-paid-in-capital--sym
          :holding/cur-distributions
          :holding/cur-distributions--sym
          :holding/cur-residual-value
          :holding/cur-residual-value--sym
          :holding/priority
          :holding/exit-plan
          :holding/recent-status])

(defonce exit-oppo-create-attributes
  [:exit-opportunity/name
   :exit-opportunity/owner
   :exit-opportunity/datetime-expected-closing-date
   :exit-opportunity/cur-expected-EV
   :exit-opportunity/cur-expected-EV--sym
   :exit-opportunity/probability-percentage])

(defonce fund-commitment-create-attributes
         [:fund-commitment/investor
          :fund-commitment/cur-committed-amount
          :fund-commitment/cur-committed-amount--sym
          :fund-commitment/closing-information
          :fund-commitment/owner
          :fund-commitment/fund
          :fund-commitment/committed-date
          :fund-commitment/won-by
          :fund-commitment/credit])
(defonce oppo-create-attributes
         [:oppo/name
          :oppo/pipeline
          :oppo/lead-type-v2
          :oppo/lead-source-v2
          :oppo/owner
          :oppo/target-asset])
(defonce fund-create-attributes
         [:fund/name
          :fund/teams
          :fund/reporting-admins])
(defonce investor-create-attributes
         [:investor/legal-entity
          :investor/investor-type
          :investor/owner
          :investor/description
          :investor/preferred-currency
          :investor/type
          :investor/language
          :investor/investor-types])
(defonce pipeline-create-attributes [:pipeline/name :pipeline/target-asset-types])

(def tesi-company-attrs
  [:asset/name
   :company/business-id
   :company/website
   :asset/description
   :company/tesi-main-industry-usual-suspects
   :company/tesi-pitchbook-verticals
   :company/tag-tags
   :company/tag-type
   :asset/country
   :asset/city
   :company/tag-portfolios
   :company/attractiveness
   :company/company-owner
   :company/competition
   :company/market-overview
   :company/risks-and-challenges
   :company/number-of-employees
   :company/number-of-employees-in-Finland])

(def f-log-company-attrs
  [:asset/name
   :asset/description
   :company/website
   :asset/country
   :asset/city
   :company/tag-tags
   :company/company-owner])

(def f-log-deal-attrs
  [:oppo/name
   :oppo/status-and-next-steps
   :oppo/deal-description
   :oppo/funding-round-v2
   :oppo/lead-source-v2
   :oppo/lead-source-comment])

(def tesi-deal-attrs
  [:oppo/name
   :oppo/case-note
   :oppo/owner
   :oppo/target-asset
   :oppo/lead-type-v2
   :oppo/investment-stage
   :oppo/cur-ticket
   :oppo/cur-total-round-size-equity
   :oppo/opt-17592200887814-initial
   :oppo/opt-17592200887814-investor])

(def tesi-investor-attrs
  [:investor/legal-entity
   :investor/description
   :investor/investor-types
   :investor/focus-sector
   :investor/focus-geography])

(def tesi-holding-attrs
  [:holding/name
   :holding/owner
   :holding/target-asset
   :holding/tag-tags])

(def voima-mandatory-deal-attrs
  [:oppo/name
   :oppo/stage
   :oppo/lead-source-v2
   :oppo/owner
   :oppo/investment-segment])

(def eq-fof-asset-attrs
  [:asset/name
   :fof-asset/fund-status
   :fof-asset/int-17592375854634-vintage-year
   :fof-asset/tag-vintage-year
   :fof-asset/date-of-incorporation
   :asset/country
   :fof-asset/cur-current-size
   :fof-asset/cur-17592375854634-fund-size
   :asset/description
   :fof-asset/target-asset-class
   :fof-asset/geography
   :fof-asset/cur-target-size
   :fof-asset/hard-cap
   :fof-asset/consideration-for
   :fof-asset/fund-size-increase
   :fof-asset/closed
   :fof-asset/expected-first-close
   :fof-asset/expected-final-close
   :fof-asset/ev-target-lower-end
   :fof-asset/ev-target-higher-end
   :fof-asset/ebitda-lower-end
   :fof-asset/ebitda-higher-end
   :fof-asset/tag-sector
   :fof-asset/eq-re-up
   :fof-asset/expected-to-be-oversubscribed
   :fof-asset/team-location
   :fof-asset/geographical-focus
   :fof-asset/investment-strategy-in-nutshell
   :fof-asset/sfdr-art
   :fof-asset/esg-score
   :fof-asset/founded
   :fof-asset/eq-relationship
   :fof-asset/investment-strategy
   :fof-asset/team-comment
   :fof-asset/track-record
   :fof-asset/track-record-text
   :fof-asset/incentives
   :fof-asset/management-fee
   :fof-asset/carried-interest
   :fof-asset/gp-commitment
   :fof-asset/fee-offset
   :fof-asset/fee-offset-comment
   :fof-asset/key-man
   :fof-asset/pros
   :fof-asset/cons
   :fof-asset/firm
   :fof-asset/firm-comment
   :fof-asset/team
   :fof-asset/team-comment
   :fof-asset/incentive
   :fof-asset/incentive-comment
   :fof-asset/strategy
   :fof-asset/strategy-single-option
   :fof-asset/tag-strategy
   :fof-asset/strategy-comment
   :fof-asset/performance
   :fof-asset/performance-comment
   :fof-asset/terms
   :fof-asset/terms-comment
   :fof-asset/limited-access
   :fof-asset/limited-access-comment
   :fof-asset/co-investments
   :fof-asset/co-investments-comment
   :fof-asset/esg
   :fof-asset/esg-comment
   :fof-asset/re-up
   :fof-asset/re-up-comment
   :fof-asset/portfolio-fit
   :fof-asset/initial-risk-score
   :fof-asset/investment-stage])
